import React, { useEffect } from "react";
import PropTypes from "prop-types";

import "./topicDesktop.scss";

import BreadCrumb from "../BreadCrumb/breadCrumb";
import SideNavbar from "../SideNavbar/sideNavbar";
import VerticalLine from "../VerticalLine/verticalLine";
import Section from "../Section/section";
import { EVENTS, TEMPLATES } from "../../utils/constants";
import CTALabel from "../../components/CTALabel/ctaLabel";
import { isTokenPresent } from "../../utils/cookieHelper";
import {
  ingestData,
  isWeb,
} from "../../bridges/BridgeServices";

const TopicDesktop = ({ uri = "", allPagesData = {} }) => {
  const {
    "child-pages": childPages = [],
    ctaDetails = null,
    title = "",
  } = allPagesData[uri] || {};

  let sectionChildPages = [];
  let faqChildPages = [];

  for (let child of childPages) {
    const { templateName = "" } = allPagesData[child] || {};
    if (templateName === TEMPLATES.FAQ) {
      faqChildPages.push(child);
    }
    if (templateName === TEMPLATES.SECTION) {
      sectionChildPages.push(child);
    }
  }

  useEffect(() => {
    if (isWeb()) {
      ingestData({
        name: EVENTS.FAQ_SUBCATEGORY_LOADED,
        data: {
          faqTitle: title,
        },
      });
    }
  });

  return (
    <div className="topic-desktop">
      <BreadCrumb uri={uri} allPagesData={allPagesData} />
      <div className="topic-grid">
        <SideNavbar uri={uri} allPagesData={allPagesData} />
        <VerticalLine />
        <div>
          <Section
            sectionPages={faqChildPages}
            allPagesData={allPagesData}
          />
          <Section
            sectionPages={sectionChildPages}
            allPagesData={allPagesData}
          />
          {ctaDetails && isTokenPresent() && (
            <CTALabel
              faqTitle={title}
              {...ctaDetails}
              className="cta-topic-desktop"
            />
          )}
        </div>
      </div>
    </div>
  );
};

TopicDesktop.propTypes = {
  uri: PropTypes.string,
  allPagesData: PropTypes.object,
  activeUri: PropTypes.string,
};

export default TopicDesktop;
